import React, { useEffect, useState } from "react";
// import "./GotraKuldevi.css";
import "../styles/GotraKuldevi.css";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import config from "../services/config";
import Loader from "../utilities/Loader";
import { showAlert } from "../utilities/alertService";
import KuldeviProfile from "./KuldeviProfile";
import KuldeviDetails from "./KuldeviDetails";

const GotraKuldevi = () => {
    const [gotraList, setGotraList] = useState([]);
    const [kuldeviList, setKuldeviList] = useState([]);
    const [heritageList, setHeritageList] = useState([]);
    const [gotraPdf, setGotraPdf] = useState(null);
    const [kuldevipdf, setKuldeviPdf] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedKuldeviId, setSelectedKuldeviId] = useState(null);

    const fetchGotraKuldeviData = async () => {
        try {
            setLoading(true);
            const payload = { company_id: 1 }
            // Example API calls (replace with your real ones)
            const gotraRes = await config.getGotraList(payload);
            const kuldeviRes = await config.getKuldeviListForCustomer(payload);
            const gotraPdfRes = await config.downloadGotraPdf(payload);
            console.log('gotraPdfRes', gotraPdfRes)
            const kuldeviPdfRes = await config.downloadKuldeviPdf(payload);
            console.log('kuldeviPdfRes', kuldeviPdfRes)
            if (gotraRes?.status === true) {
                setGotraList(gotraRes.data);
            }
            if (kuldeviRes?.status === true) {
                setKuldeviList(kuldeviRes.data);
            }
            if (gotraRes?.status === true) {
                setGotraPdf(gotraPdfRes.pdf_base64);
            }
            if (gotraRes?.status === true) {
                setKuldeviPdf(kuldeviPdfRes.pdf_base64);
            }
        } catch (error) {
            console.error("❌ Error fetching Gotra/Kuldevi data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getCategoeryData = async () => {
        try {
            setLoading(true);
            const payload = {
                company_id: 1,
                category_id: 100, // Example category ID
            };
            const heritageRes = await config.getResourceData(payload);
            console.log("heritageRes:", heritageRes);
            if (heritageRes?.success === true && heritageRes.data?.length > 0) {
                setHeritageList(heritageRes.data);

            } else {
                showAlert("error", "Failed to fetch Hamari dharohar data");
            }
        } catch (error) {
            console.error("Error fetching category data:", error);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGotraKuldeviData();
        getCategoeryData();
    }, []);

    const handleDownload = async (item) => {
        setLoading(true);
        try {
            
            // 🔹 Step 1 — Fetch data from API
            const payload = { id: item.id };
            const response = await config.getBookImagesByResourceId(payload);
            console.log("patrika:", response);

            // ✅ Step 2 — Validate response
            if (!response?.success || !response.data || response.data.length === 0) {
                showAlert("error", "No image or PDF found for this record.");
                return;
            }

            // 🔹 Step 3 — Extract base64 content
            const fileData = response.data[0];
            const base64Data = fileData.image_path;

            if (!base64Data) {
                showAlert("error", "File missing or invalid Base64 data.");
                return;
            }

            // 🔹 Step 4 — Detect file type
            const isPdf = base64Data.startsWith("data:application/pdf");
            const isImage = base64Data.startsWith("data:image/");
            let extension = "file";

            if (isPdf) extension = "pdf";
            else if (isImage) {
                const match = base64Data.match(/^data:image\/(.*?);base64,/);
                extension = match ? match[1] : "png";
            }

            // 🔹 Step 5 — Create download link dynamically
            const link = document.createElement("a");
            link.href = base64Data;
            link.download = `book_${item.title_name}.${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            console.log(`✅ Download started: patrika_${item.id}.${extension}`);
        } catch (error) {
            console.error("Error fetching Patrika data:", error);
            showAlert("error", "Failed to download file.");
        } finally {
            setLoading(false);
        }
    };

    const handlePdfDownload = (pdfData, fileName = "File.pdf") => {
        try {
            if (!pdfData) {
                showAlert("error", "No PDF data available to download.");
                return;
            }

            // Remove possible Base64 prefixes like "data:application/pdf;base64,"
            const base64String = pdfData.includes(",")
                ? pdfData.split(",")[1]
                : pdfData;

            // Decode Base64 and create Blob
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length)
                .fill()
                .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            // Create temporary download link
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error("Error downloading PDF:", error);
            showAlert("error", "Failed to download the PDF.");
        }
    };

    // ✅ Popup close handler
    const closePopup = () => setSelectedKuldeviId(null);

    return (
        <div className="bhrigu-container">
            {loading && <Loader />}
            {/* गोत्र Section */}
            <div className="section gotra-section">
                <h2 className="vertical-text">गोत्र</h2>
                <div className="list-grid">
                    {gotraList.map((item, index) => {
                        const formatText = (text) =>
                            text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";

                        return (
                            <div key={index} className="list-item">
                                <span> {formatText(item.name)}</span>  <span className="devnagri">({formatText(item.hindi_name)})</span>
                            </div>
                        );
                    })}
                </div>
                <div className="download-link"
                onClick={() => handlePdfDownload(gotraPdf, "Gotra_List.pdf")}
                title="Download PDF List"
                >
                    Download List - PDF ▼</div>
            </div>

            {/* कुलदेवी Section */}
            <div className="section kuldevi-section">
                <h2 className="vertical-text">कुलदेवी</h2>
                <div className="list-grid">
                    {kuldeviList.map((item, index) => {
                        const formatText = (text) =>
                            text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";

                        return (
                            <div key={index} className="list-item"
                                onClick={() => setSelectedKuldeviId(item)}
                            >
                                <span> {formatText(item.name)}</span> <span className="devnagri">({formatText(item.hindi_name)})</span>
                            </div>
                        );
                    })}
                </div>
                <div className="download-link"
                 onClick={() => handlePdfDownload(kuldevipdf, "Kuldevi_List.pdf")}
                 title="Download PDF List"
                >

                    Download List - PDF ▼</div>
            </div>

            {/* हमारी धरोहर Section */}
            <div className="section heritage-section">
                <div className="heritage-header">
                    <div className="logo-section textcenter">
                        <div>
                            <img src={bhrigu_logo} alt="Bhrigu Logo" style={{ width: '70%', margin: '0px' }} />
                        </div>
                    </div>
                    <h2 className="heritage-title">हमारी धरोहर</h2>
                </div>

                <ul className="heritage-list">
                    {heritageList.map((item, index) => (
                        <li key={index} className="heritage-item">
                            {item.title_name}
                            <span>
                                <span className="open-flipbook-link"
                                    onClick={() => window.open(item.title_url, "_blank")}
                                    title="Open Flipbook"
                                >FB</span>
                                <span className="dropdown-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(item);
                                    }}
                                    title="Download File"
                                >
                                    ▼
                                </span>
                            </span>
                        </li>
                    ))}
                </ul>

                {/* <div className="download-link">Download List · PDF ▼</div> */}
            </div>
            {/* ✅ Modal Popup for KuldeviProfile */}
            {selectedKuldeviId && (
                <div className="modal-overlay" onClick={closePopup}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
                    >
                        <button className="close-btn" onClick={closePopup}>
                            ✕
                        </button>
                        {/* <KuldeviProfile kuldeviId={selectedKuldeviId} /> */}
                        <KuldeviDetails kuldeviId={selectedKuldeviId} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GotraKuldevi;
